import { Biophysics as BiophysicsUi } from '../components';

import { useCurrentLocation } from '../providers/CurrentLocationProvider/CurrentLocationProvider';

const Biophysics = () => {
  const { latLng, setLatLng } = useCurrentLocation();

  return <BiophysicsUi onLatLng={setLatLng} initialLocation={latLng} />;
};

export default Biophysics;
